import { useState } from 'react';
import { useGetMemberProfileMutation } from '@services/member/member/member.endpoints';
import { MemberTable } from '@services/member/member/member.types';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

export const useDetailsPageVM = () => {
    const { id } = useParams();
    const [member, setMember] = useState<MemberTable>();

    const [
        getMember,
        {
            isLoading: isGetMemberLoading,
            isError: isGetMemberError,
            isSuccess: isGetMemberSuccess,
            error: getMemberError,
            data: getMemberResponse
        }
    ] = useGetMemberProfileMutation();
    

    useEffect(() => {
        if (!id) return;
        getMember({ id });
    }, [id]);

    useEffect(() => {
        if (isGetMemberLoading) return;
        if (isGetMemberError) return;
        if (getMemberError) return;

        if (isGetMemberSuccess && getMemberResponse) {
            setMember(getMemberResponse.data);
        }
    }, [isGetMemberError, isGetMemberSuccess, getMemberError, getMemberResponse, isGetMemberLoading]);

    return {
        member
    };
};
